import React from 'react'
import PropTypes from 'prop-types'

const Fire = ({ active = false }) => {
  const color = active ? '#FA8128' : '#939393'
  return (
    <svg width='16' height='21' viewBox='0 0 16 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M13.6267 7.36397C13.1734 6.97198 12 6.10402 11.8934 6.02002C10.5067 4.73192 9.97343 3.52801 10.5067 1.28796C10.6401 0.728011 10.2934 0.16806 9.76005 0.0280093C9.54669 -0.0280457 9.30674 7.99373e-05 9.09338 0.111995C5.81343 1.7921 4.48009 5.32 4.74667 8.45601C4.31996 7.78396 4.08 7.02805 4.02662 6.21595C3.97323 5.62785 3.49333 5.20795 2.93324 5.264C2.6399 5.29193 2.34657 5.48803 2.18657 5.73998C0.533285 8.42788 0 10.024 0 12.6C0 17.248 3.57329 21 8 21C12.4267 21 16 17.248 16 12.6C16 10.3599 15.1466 8.70798 13.6267 7.36398V7.36397ZM8 18.928C4.69329 18.928 2 16.128 2 12.656V12.628C2 10.5001 2.42671 9.74404 2.72005 8.98799C3.46671 10.528 4.72005 11.536 6 11.536C6.5601 11.536 7.01338 11.0601 7.01338 10.5001C7.01338 10.4161 7.01338 10.3601 6.98678 10.2761C6.13335 6.04811 7.65345 3.92006 8.32012 3.24806C8.4267 5.01211 9.25354 6.32816 10.5601 7.58812C10.7734 7.78421 12 8.68012 12.3201 8.98812C13.4135 9.96822 14.0002 11.0602 14.0002 12.6282C14.0268 16.1002 11.3601 18.9282 8.08016 18.9282C8.05338 18.928 8.02659 18.928 7.99999 18.928H8Z' fill={color}/>
    </svg>
  )
}

Fire.propTypes = {
  active: PropTypes.bool
}

export default Fire
